import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import React, { ComponentProps } from 'react';
import { SonForm } from '../../_lib/Form2';
import { StatusInfoError } from '../../_lib/components/StatusInfo';
import { StatusInfoModifier } from '../../_lib/components/StatusInfo/partials/StatusInfo';
import { ConfirmEmailAddressForm, ConfirmEmailAddressFormTypes } from './partials/ConfirmEmailAddressForm';
import { useSonTranslation } from '../../translation/useSonTranslation';

type ChangeEmailAddressProps = {
  errorType?: string; // BE: SonDisplayableErrorType
  newEmailAddress?: string;
  confirmForm?: SonForm<ConfirmEmailAddressFormTypes>;
};

function ChangeEmailAddress({ errorType, newEmailAddress, confirmForm }: ChangeEmailAddressProps) {
  const { t } = useSonTranslation('ChangeEmailAddress');

  if (errorType) {
    return (
      <StatusInfoError
        // @ts-expect-error dynamic label typing
        message={t(`errorType.${errorType}`)}
        modifier={[
          StatusInfoModifier.RED,
          StatusInfoModifier.ALIGN_LEFT,
          StatusInfoModifier.MARGIN_LEFT_LARGE,
          StatusInfoModifier.MARGIN_BOTTOM,
        ]}
      />
    );
  }

  if (confirmForm && newEmailAddress) {
    return <ConfirmEmailAddressForm form={confirmForm} newEmailAddress={newEmailAddress} />;
  }

  return null;
}

export const ChangeEmailAddressBlock = asFetchableBlock(ChangeEmailAddress, BlockType.changeEmailAddress);
export type ChangeEmailAddressBlock = ComponentProps<typeof ChangeEmailAddressBlock>;
